module.exports = __webpack_public_path__ + "img/right_foot_on.7f138741.png";